// Sticky "PERSONNALISER" bar for design products.
// Mobile only (hidden on desktop via CSS): slides up when the real configurator
// CTA scrolls out of view and slides back down while it stays reachable. The
// real button is re-queried on click because the configurator can rebuild it
// asynchronously (a captured reference would go stale). Clicking the bar proxies
// the real button so the existing handler (w-product-template.js) stays the
// single source of truth.
(function () {
  const bar = document.querySelector("[data-sticky-personnaliser]");
  if (!bar) return;

  const getBtn = () => document.querySelector(".open-configurateur");

  // Mirror the main price block. It swaps between "à partir de X €" and the
  // per-quantity total when the customer picks a quantity, so keep the sticky
  // price in sync with whatever the main block currently shows.
  const priceSource = document.querySelector(".product-info__price");
  const priceTarget = bar.querySelector(".sticky-personnaliser__price");

  function syncPrice() {
    if (priceSource && priceTarget) priceTarget.innerHTML = priceSource.innerHTML;
  }

  syncPrice();

  if (priceSource && "MutationObserver" in window) {
    new MutationObserver(syncPrice).observe(priceSource, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  bar.querySelector(".sticky-personnaliser__btn").addEventListener("click", () => {
    const btn = getBtn();
    if (btn) btn.click();
  });

  // Reveal the bar (slide up) only once the real "PERSONNALISER" button leaves
  // the viewport; hide it (slide down) while that button is still reachable in
  // the product form. Desktop hides the bar via CSS, so this drives mobile.
  // Observe a stable ancestor of the button: the configurator can rebuild the
  // button itself, which would detach an observer bound directly to it.
  const anchor = document.querySelector(".product-info__add-button") || getBtn();
  if (anchor && "IntersectionObserver" in window) {
    new IntersectionObserver(
      ([entry]) => bar.classList.toggle("is-visible", !entry.isIntersecting),
      { threshold: 0 }
    ).observe(anchor);
  } else {
    bar.classList.add("is-visible");
  }
})();
